'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scatterStateFromNewProps = exports.onChangeScatterVal = exports.scatterStateValueToOption = exports.onChangeScatterDim = exports.scatterValueOptions = exports.isScatter = exports.toScatterSingularity = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');

var _constants = require('../constants');

var _utils = require('./utils');

var _focus = require('./focus');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getScatterDimension = (0, _utils.getPropertyDimension)('scatterDimension');

var toScatterState = function toScatterState(dim, xVal, yVal) {
  return {
    scatterDimension: (0, _utils.toState)(dim),
    scatterX: (0, _utils.toState)(xVal),
    scatterY: (0, _utils.toState)(yVal)
  };
};

var toScatterSingularity = exports.toScatterSingularity = function toScatterSingularity(state) {
  return {
    id: R.prop('scatterDimension', state),
    xId: R.prop('scatterX', state),
    yId: R.prop('scatterY', state)
  };
};

var isScatter = exports.isScatter = function isScatter(type) {
  return type === _constants.SCATTER;
};

var scatterValueOptions = exports.scatterValueOptions = function scatterValueOptions(_ref, state) {
  var data = _ref.data,
      type = _ref.type,
      display = _ref.display;

  if (!isScatter(type)) {
    return [];
  }
  var scatterDimension = getScatterDimension(data, state);
  if (R.isNil(scatterDimension)) {
    return [];
  }
  return R.map((0, _utils.artefactToOption)(display), R.prop('values', scatterDimension));
};

var onChangeScatterDim = exports.onChangeScatterDim = function onChangeScatterDim(props, state) {
  return function (value) {
    var data = props.data;

    var dimension = getScatterDimension(data, { scatterDimension: value });
    if (R.isNil(dimension)) {
      return {};
    }

    var _R$take = R.take(2, R.prop('values', dimension)),
        _R$take2 = (0, _slicedToArray3.default)(_R$take, 2),
        xVal = _R$take2[0],
        yVal = _R$take2[1];

    var newScatterState = toScatterState(dimension, xVal, yVal);

    return (0, _extends3.default)({}, newScatterState, (0, _focus.focusStateFromNewProps)(props, toScatterSingularity(newScatterState), state));
  };
};

var scatterStateValueToOption = exports.scatterStateValueToOption = function scatterStateValueToOption(property, props, state) {
  var dimension = getScatterDimension(props.data, state);
  if (R.isNil(dimension) || !isScatter(props.type)) {
    return undefined;
  }
  var value = R.find(R.propEq('id', R.prop(property, state)), R.prop('values', dimension));
  return (0, _utils.artefactToOption)(props.display)(value);
};

var onChangeScatterVal = exports.onChangeScatterVal = function onChangeScatterVal(_ref2, state, valKey, otherValKey) {
  var data = _ref2.data,
      type = _ref2.type;
  return function (value) {
    var _ref3;

    var options = scatterValueOptions({ data: data, type: type }, state);

    var _R$partition = R.partition(R.propEq('value', value), options),
        _R$partition2 = (0, _slicedToArray3.default)(_R$partition, 2),
        matching = _R$partition2[0],
        otherOptions = _R$partition2[1];

    if (R.isEmpty(matching)) {
      return {};
    }
    var stateOtherValue = R.prop(otherValKey, state);
    return _ref3 = {}, (0, _defineProperty3.default)(_ref3, valKey, value), (0, _defineProperty3.default)(_ref3, otherValKey, stateOtherValue === value ? R.prop('value', R.head(otherOptions)) : stateOtherValue), _ref3;
  };
};

//----------------------------------------------------------------------------------------------------

var scatterStateFromNewProps = exports.scatterStateFromNewProps = function scatterStateFromNewProps(props, state) {
  var data = props.data,
      type = props.type;

  var undefinedState = toScatterState(undefined, undefined, undefined);
  if (!isScatter(type)) {
    return undefinedState;
  }
  if (R.isNil(data)) {
    return {};
  }
  var dimensions = (0, _utils.getDimensionsWithValues)(data);
  if (R.isEmpty(dimensions)) {
    return (0, _extends3.default)({}, undefinedState, { highlight: [], baseline: [] });
  }

  var scatterDimension = getScatterDimension(props.data, state);
  if (R.isNil(scatterDimension)) {
    var refinedDimensions = R.reject(_dotstatsuiteSdmxjs.isRefAreaDimension, dimensions);
    scatterDimension = R.head(R.isEmpty(refinedDimensions) ? dimensions : refinedDimensions);
  }

  var values = R.prop('values', scatterDimension);

  var stateScatterX = R.prop('scatterX', state);
  var stateScatterY = R.prop('scatterY', state);

  if (stateScatterX === stateScatterY) {
    stateScatterY = undefined;
  }

  var _scatterX = undefined;
  var _scatterY = undefined;

  R.forEach(function (value) {
    if (R.prop('id', value) === stateScatterX) {
      _scatterX = value;
    } else if (R.prop('id', value) === stateScatterY) {
      _scatterY = value;
    }
  }, values);

  //dirty as f
  var scatterX = R.isNil(_scatterX) ? R.head(R.reject(R.propEq('id', R.prop('id', _scatterY)), values)) : _scatterX;
  var scatterY = R.isNil(_scatterY) ? R.head(R.reject(R.propEq('id', R.prop('id', scatterX)), values)) : _scatterY;

  var scatterState = toScatterState(scatterDimension, scatterX, scatterY);

  return (0, _extends3.default)({}, scatterState, (0, _focus.focusStateFromNewProps)(props, toScatterSingularity(scatterState), state));
};